// hooks/useDocuments.ts
import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, Timestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { User } from 'firebase/auth';
import { Document } from '../components/DocumentTile';

export function useDocuments(user: User | null) {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setLoading(false);
      return;
    }
    
    
    const q = query(collection(db, 'invoices'), where('userId', '==', user.uid));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const docs: Document[] = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        docs.push({
          id: doc.id,
          documentId: data.documentId || '',
          title: data.name || data.title || 'Untitled',
          sender: data.sender || 'Unknown',
          createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate() : 
                     data.creationDate instanceof Timestamp ? data.creationDate.toDate() : 
                     new Date(),
          detectedDocumentCategory: data.detectedDocumentCategory || 'Unknown',
          status: data.status || 'submitted',
          taskCount: data.taskCount || 0,
          doneTaskCount: data.doneTaskCount || 0,
          // Map additional fields
          currency: data.currency,
          dueDate: data.dueDate,
          invoiceDate: data.invoiceDate,
          invoiceNumber: data.invoiceNumber,
          paymentTerms: data.paymentTerms,
          receiver: data.receiver,
          senderWebsiteUrl: data.senderWebsiteUrl,
          summary: data.summary,
          subtotal: data.subtotal,
          taxAmount: data.taxAmount,
          totalAmount: data.totalAmount,
          userId: data.userId,
          content: data.content, // Add the content field for AI analysis
          fileName: data.filename || data.fileName, // Firestore uses 'filename' (lowercase)
        });
      });

      setDocuments(docs.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()));
      setLoading(false);
    }, (error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Error fetching documents:', error);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user?.uid]);

  return { documents, loading };
}